import React, { useState } from 'react';
import { Form, InputNumber, Modal } from 'antd';
import { FormattedMessage } from 'react-intl';

/**
 * This component represents an update cost center modal.
 * @param props - the props
 */
export const UpdateCostCenterModal: React.FC<Props> = (props) => {
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);

    const cancel = async () => {
        form.resetFields();
        props.onCancel();
    };

    const update = async () => {
        try {
            setSaving(true);
            const values = await form.validateFields();
            await props.onUpdate(values);
            form.resetFields();
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            title={<FormattedMessage id="projectMembers.updateCostCenter.modal.title" />}
            visible={props.visible}
            onCancel={cancel}
            onOk={update}
            okButtonProps={{ loading: saving }}
            cancelButtonProps={{ disabled: saving }}
            width={300}
        >
            <Form form={form} colon={false} layout="vertical">
                <Form.Item
                    label={<FormattedMessage id="projectMembers.updateCostCenter.modal.description" />}
                    name="costCenter"
                    rules={[{ required: props.mandatory, message: <FormattedMessage id="status.mandatory" /> }]}
                >
                    <InputNumber size="large" maxLength={4} min={0} />
                </Form.Item>
            </Form>
        </Modal>
    );
};
export default UpdateCostCenterModal;

interface Props {
    visible?: boolean;
    onUpdate: (values: any) => Promise<void>;
    onCancel: () => void;
    mandatory?: boolean;
}
